var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SubdistributorList',{attrs:{"distributor_id":_vm.distributor_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }